import { createContext, useContext } from 'react';
import type { EagColumnState } from '../types/EagColumnState';
import type { FilterState } from '../types/FilterState';
export type ColumnMenuContextValue = {
  /** Whether the column header menu feature is enabled at all */
  showColumnMenu: boolean;
  /** Whether column pinning actions are shown in the menu */
  showPinning: boolean;
  /** Whether column autosize actions are shown in the menu */
  showAutosize: boolean;
  /** Current committed filter values (read-only view for the filter tab) */
  filterState: FilterState;
  /** Read-only map of column states — used to read sort direction per column in the menu */
  columnStates: Map<string, EagColumnState>;
  onFilterChange: (key: string, value: unknown) => void;
  onPinColumn: (key: string, pinned: 'LEFT' | 'RIGHT' | null) => void;
  onAutosizeColumn: (key: string) => void;
  onAutosizeAllColumns: () => void;
  onResetColumns: () => void;
  onResetFilters: () => void;
  /** Set sort direction directly for a column (not toggle — Options tab sets exact value) */
  onSort: (key: string, sort: 'ASC' | 'DESC' | null) => void;
};
export const ColumnMenuContext = createContext<ColumnMenuContextValue | null>(null);
export function useColumnMenuContext(): ColumnMenuContextValue {
  const ctx = useContext(ColumnMenuContext);
  if (ctx === null) {
    throw new Error('useColumnMenuContext must be used inside ColumnMenuContext.Provider');
  }
  return ctx;
}